import { useEffect, useState } from 'react';

import type { RgbString } from 'lib/colors';
import { getProminentColor } from 'lib/colors';

export const useMainColor = (url: string | undefined) => {
  const [mainColor, setMainColor] = useState<RgbString>('0, 0, 0');

  useEffect(() => {
    if (url) {
      getProminentColor(url, { amount: 1 }).then(colors => {
        const [color] = colors;
        if (Array.isArray(color)) {
          setMainColor(color.join(', ') as RgbString);
        }
      });
    }
  }, [url]);

  return mainColor;
};
